// src/utils/complianceCalculator.js

/**
 * Calculates compliance percentage based on answer value
 * @param {string} value - The answer value
 * @param {string} additionalInfo - Additional information provided (used for not_implemented percentage)
 * @returns {number} - Percentage value between 0 and 100
 */
export const getCompliancePercentage = (value, additionalInfo = '') => {
  switch (value) {
    case 'effective': return 100;
    case 'alternate_control': return 100;
    case 'ineffective': return 0;
    case 'not_assessed': return 0;
    case 'no_visibility': return 0;
    case 'not_implemented': 
      // Try to parse percentage from additional info
      const percentage = parseInt(additionalInfo);
      return !isNaN(percentage) && percentage >= 0 && percentage <= 100 ? percentage : 0;
    case 'not_applicable': return 100;
    default: return 0;
  }
};
  
/**
 * Calculates compliance for a specific set of questions
 */
export const calculateControlCompliance = (answers, controlQuestions) => {
  if (!controlQuestions || controlQuestions.length === 0) return 0;

  const answeredQuestions = controlQuestions.filter(q => 
    answers[q.id] && answers[q.id].value !== ''
  );
  
  if (answeredQuestions.length === 0) return 0;

  const totalCompliance = answeredQuestions.reduce((sum, question) => {
    const answer = answers[question.id];
    return sum + getCompliancePercentage(answer?.value || '', answer?.additionalInfo || '');
  }, 0);

  return (totalCompliance / (controlQuestions.length * 100)) * 100;
};